// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"54df0d5b","207":"b3a4b6df","404":"5091a7d7","453":"a1111a92","608":"d83aa81c","687":"d3a9c037","742":"8ca7133b","846":"ad635bb9"}[chunkId] + ".chunk.js";
};